import {floatToTime, timeToFloat} from '../../time';
import {getBase64ImageWithHeader} from '../../utils'
import { isPPS } from './analyseRisquesStatusActions'
import {getDefaultParticipants, getDefaultCompanies} from './analyseRisquesActions'
import moment from 'moment';

export function castToDbFormat(analyseRisquesState){
    let ar = analyseRisquesState.header;
    ar.afternoonScheduleEnd = ar.afternoonScheduleEnd.toString();
    ar.expectedEndDate = ar.expectedEndDate.toString();
    ar.afternoonScheduleStart = ar.afternoonScheduleStart.toString();
    ar.jointInspectionDate = ar.jointInspectionDate.toString();
    ar.morningScheduleEnd = ar.morningScheduleEnd.toString();
    ar.morningScheduleStart = ar.morningScheduleStart.toString();
    ar.startDate = ar.startDate.toString();

    ar.participants = analyseRisquesState.participants;
    ar.raCompanies = analyseRisquesState.raCompanies;
    ar.sppCompanies = analyseRisquesState.sppCompanies;

    ar.risks = analyseRisquesState.risks;

    return ar;
}

function castParticipantsToServerFormat(participants){

    participants = participants.filter((p) => p.concerned || p.customer || p.typeId === "ee1").map((p) => {
        let newParticipant = {
            type: p.typeId,
            works: p.works,
            nb_participant: p.numberOfParticipants,
            nb_interim: p.numberOfInterimaires,
            supplier_id: p.supplier ? p.supplier.value : undefined,
            tabletSupplierRef: p.tabletSupplierRef,
        }

        return JSON.stringify(newParticipant);
    })

    return participants;
}

function castCompaniesToServerFormat(companies, sppId, isSpp){
    companies = companies.filter((c) => c.concerned).map((c) => {
        let signatureWithoutBase64FirstPart;

        if(c.signature)
            signatureWithoutBase64FirstPart = c.signature.replace(/^data:image\/[a-z]+;base64,/, "");

        let newCompany = {
            name: c.name,
            type: c.type.id,
            email: c.email,
            signatory: signatureWithoutBase64FirstPart,
            is_spp_signature: isSpp,
        }

        return JSON.stringify(newCompany);
    })

    return companies;
}

function castRisksToServerFormat(risks){

    risks = risks.filter((r) => r.id !== 0).map((r) => {
        let imageWithoutBase64FirstPart;

        if(r.image)
            imageWithoutBase64FirstPart = r.image.replace(/^data:image\/[a-z]+;base64,/, "");

        let newRisk = {
            id: r.id,
            risk_id: r.riskTypeId,
            risk_photo: imageWithoutBase64FirstPart,
            risk_line_measure_ids: castMeasuresToServerFormat(r.solutions, r.id),
        }

        return JSON.stringify(newRisk);
    })

    return risks;
}

function castMeasuresToServerFormat(measures, riskId){
    measures = measures.filter(m => m.id !== 0).map((m) => {
        let newMeasure = {
            risk_line_id: riskId,
            risk_measure_id: m.solutionTypeId,
            eu: m.concernedCompanies.some(c => c.company.id === "eu" && c.concerned),
            ee1: m.concernedCompanies.some(c => c.company.id === "ee1" && c.concerned),
            ee2: m.concernedCompanies.some(c => c.company.id === "ee2" && c.concerned),
            ee3: m.concernedCompanies.some(c => c.company.id === "ee3" && c.concerned),
            ee4: m.concernedCompanies.some(c => c.company.id === "ee4" && c.concerned),
            ee5: m.concernedCompanies.some(c => c.company.id === "ee5" && c.concerned),
            ee6: m.concernedCompanies.some(c => c.company.id === "ee6" && c.concerned),
            ee7: m.concernedCompanies.some(c => c.company.id === "ee7" && c.concerned),
            ee8: m.concernedCompanies.some(c => c.company.id === "ee8" && c.concerned),
            comment: m.comment,
        }

        return JSON.stringify(newMeasure);
    })

    return measures;
}

export function castAnalyseRisquesToServerFormat(analyseRisquesState){

    let customerRefTablet;

    if(analyseRisquesState.header.numOt && !analyseRisquesState.header.ot)
        customerRefTablet = analyseRisquesState.header.numOt;

    if(analyseRisquesState.header.affairInput && !analyseRisquesState.header.affair)
        customerRefTablet = analyseRisquesState.header.affairInput;

    let morningScheduleStart = new Date(analyseRisquesState.header.morningScheduleStart);
    let morningScheduleEnd = new Date(analyseRisquesState.header.morningScheduleEnd);
    let afternoonScheduleStart = new Date(analyseRisquesState.header.afternoonScheduleStart);
    let afternoonScheduleEnd = new Date(analyseRisquesState.header.afternoonScheduleEnd);

    let analyseRisques = {
        //OneToMany
        participant_ids: castParticipantsToServerFormat(analyseRisquesState.participants, analyseRisquesState.header.mobileId),
        risk_line_ids: castRisksToServerFormat(analyseRisquesState.risks, analyseRisquesState.header.mobileId),
        ra_signatory_ids: castCompaniesToServerFormat(analyseRisquesState.raCompanies, analyseRisquesState.header.mobileId, isPPS(analyseRisquesState.header.status)),
        spp_signatory_ids: castCompaniesToServerFormat(analyseRisquesState.sppCompanies, analyseRisquesState.header.mobileId, isPPS(analyseRisquesState.header.status)),

        //header
        mobile_id: analyseRisquesState.header.mobileId,
        work_order_id: analyseRisquesState.header.ot ? analyseRisquesState.header.ot.id : undefined,
        affair_id: analyseRisquesState.header.affair ? analyseRisquesState.header.affair.id : undefined,
        delivery_address_id: analyseRisquesState.header.delivery_address,
        customer_ref_tablet: customerRefTablet,
        customer_contact_id: analyseRisquesState.header.contact,
        customer_contact_tablet: analyseRisquesState.header.customer_contact_tablet,
        state: analyseRisquesState.header.status,
        id: analyseRisquesState.header.id,

        //ICP
        joint_inspection_date: moment(analyseRisquesState.header.jointInspectionDate).format("YYYY-MM-DD"),
        information_communicated: analyseRisquesState.header.communicatedInformation,
        participants: analyseRisquesState.header.icpParticipants,

        //Security
        personal_protective_equipment_ids: analyseRisquesState.header.ppe.map((e) => e.value),
        necessary_equipment_ids: analyseRisquesState.header.necessaryEquipments,
        available_equipment_ids: analyseRisquesState.header.availableEquipments,
        specifics_equipments: analyseRisquesState.header.specificsEquipments,
        instruction_ids: analyseRisquesState.header.instructions,
        particular_instructions_given_details: analyseRisquesState.header.additionnalInformations,
        place: analyseRisquesState.header.place,
        equipment: analyseRisquesState.header.equipment,
        working_accreditation_type_ids: analyseRisquesState.header.accreditations,
        necessary_authorizations_details: analyseRisquesState.header.additionnalInformationAccreditations,

        //Works nature
        emergency_number: analyseRisquesState.header.emergencyNumber,
        nature_and_location: analyseRisquesState.header.natureAndLocation,
        on_call: analyseRisquesState.header.onCall,
        start_date: moment(analyseRisquesState.header.startDate).format("YYYY-MM-DD"),
        expected_end_date: moment(analyseRisquesState.header.expectedEndDate).format("YYYY-MM-DD"),
        local_company_id: analyseRisquesState.header.localeAgency,
        duration: analyseRisquesState.header.duration,

        morning_schedule_start: timeToFloat(morningScheduleStart.getHours(), morningScheduleStart.getMinutes()),
        morning_schedule_end: timeToFloat(morningScheduleEnd.getHours(), morningScheduleEnd.getMinutes()),
        afternoon_schedule_start: timeToFloat(afternoonScheduleStart.getHours(), afternoonScheduleStart.getMinutes()),
        afternoon_schedule_end: timeToFloat(afternoonScheduleEnd.getHours(), afternoonScheduleEnd.getMinutes()),
        planned_operations_details: analyseRisquesState.header.plannedOperationsDetails,

    };

    return analyseRisques;
}

export function castAnalyseRisquesFromServerFormat(ar, user, subcontractors){

    let morningScheduleStart = ar.morning_schedule_start;
    let morningScheduleEnd = ar.morning_schedule_end;
    let afternoonScheduleStart = ar.afternoon_schedule_start;
    let afternoonScheduleEnd = ar.afternoon_schedule_end;

    if(ar.affair_id)
        ar.affair_id.customer = ar.affair_id.delivery_partner_id;

    if(ar.work_order_id)
        ar.work_order_id.affair = ar.affair_id;

    let participants = castParticipantsFromServerFormat(ar.participant_ids, getDefaultParticipants(), subcontractors);

    let analyseRisques = {
        //OneToMany
        participants: participants,
        risks: castRisksFromServerFormat(ar.risk_line_ids, participants),
        raCompanies: castCompaniesFromServerFormat(ar.ra_signatory_ids, getDefaultCompanies(user)),
        sppCompanies: castCompaniesFromServerFormat(ar.spp_signatory_ids, getDefaultCompanies(user)),

        //header
        mobileId: ar.mobile_id,
        ot: ar.work_order_id,
        affair: ar.affair_id,
        delivery_address : ar.delivery_address_id,
        affairInput : ar.customer_ref_tablet,
        contact: ar.customer_contact_id,
        status: ar.state,
        id: ar.id,
        customer_contact_tablet: ar.customer_contact_tablet,

        //ICP
        jointInspectionDate: ar.joint_inspection_date,
        communicatedInformation: ar.information_communicated,
        icpParticipants: ar.participants,

        //Security
        ppe: ar.personal_protective_equipment_ids.map((e) => {return {value: e.id, label: e.name}}),
        necessaryEquipments: ar.necessary_equipment_ids.map((e) => {return {value: e.id, label: e.name}}),
        availableEquipments: ar.available_equipment_ids.map((e) => {return {value: e.id, label: e.name}}),
        specificsEquipments: ar.specifics_equipments,
        instructions: ar.instruction_ids.map((e) => {return {value: e.id, label: e.name}}),
        additionnalInformations: ar.particular_instructions_given_details,
        place: ar.place,
        equipment: ar.equipment,
        accreditations: ar.working_accreditation_type_ids.map((e) => {return {value: e}}),
        additionnalInformationAccreditations: ar.necessary_authorizations_details,

        //Works nature
        emergencyNumber: ar.emergency_number,
        natureAndLocation: ar.nature_and_location,
        onCall: ar.on_call,
        startDate: ar.start_date,
        expectedEndDate: ar.expected_end_date,
        localeAgency: ar.local_company_id,
        duration: ar.duration,

        morningScheduleStart: floatToTime(morningScheduleStart),
        morningScheduleEnd: floatToTime(morningScheduleEnd),
        afternoonScheduleStart: floatToTime(afternoonScheduleStart),
        afternoonScheduleEnd: floatToTime(afternoonScheduleEnd),
        plannedOperationsDetails: ar.planned_operations_details,
    };

    return analyseRisques;
}

function castParticipantsFromServerFormat(participants, allCompanies, subcontractors){

    let allParticipants = allCompanies.map((c) => {

        let currentParticipant = participants.filter((p) => c.typeId === p.type);
        let newParticipant;

        if(currentParticipant.length > 0){
            let p = currentParticipant[0];
            let subcontractorsFound = subcontractors.filter((subcontractor) => subcontractor.id === p.supplier_id);
            let goodSubcontractor;

            if(subcontractorsFound.length > 0){
                goodSubcontractor = subcontractorsFound[0];
                goodSubcontractor.label = goodSubcontractor.name;
            }

            newParticipant = {
                typeId: p.type,
                works: p.works,
                numberOfParticipants: p.nb_participant,
                numberOfInterimaires: p.nb_interim,
                supplier: goodSubcontractor,
                concerned: true,
                canChangeName: p.type !== "eu" && p.type !== "ee1"
            }
        } else
            newParticipant = c;

        newParticipant.id = newParticipant.typeId;

        return newParticipant;
    })

    return allParticipants;
}

function castCompaniesFromServerFormat(companies, allCompanies){

    let newCompanies = allCompanies.map((defaultCompany) => {

        let currentCompanies = companies.filter((c) => defaultCompany.type.id === c.type);
        let newCompany;

        if(currentCompanies.length > 0){

            let currentCompany = currentCompanies[0];
            newCompany = {
                name: currentCompany.name,
                type: {id: currentCompany.type},
                email: currentCompany.email,
                signature: currentCompany.signatory ? getBase64ImageWithHeader(currentCompany.signatory) : "",
                concerned: true
            }
        } else
            newCompany = defaultCompany;

        newCompany.id = newCompany.type.id;

        return newCompany;
    })

    return newCompanies;
}

function castRisksFromServerFormat(risks, participants){

    return risks.map((r) => {

        return {
            id: r.id,
            riskTypeId: r.risk_id,
            image: r.risk_photo,
            solutions: castMeasuresFromServerFormat(r.risk_line_measure_ids, participants),
        }
    })
}

function castMeasuresFromServerFormat(measures, participants){
    return measures.map((m) => {
        return {
            solutionTypeId: m.risk_measure_id,
            eu: m.eu,
            ee1: m.ee1,
            ee2: m.ee2,
            ee3: m.ee3,
            ee4: m.ee4,
            ee5: m.ee5,
            ee6: m.ee6,
            ee7: m.ee7,
            ee8: m.ee8,
            concernedCompanies: participants.map((p) => {return {company: p, concerned: p.concerned}}),
            comment: m.comment,
        }
    })
}
